import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import UsuarioRol from './UsuarioRol';
import * as XLSX from 'xlsx';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FormUsuario from './FormUsuario';
import { fetchUsuarios, removeUsuario } from '../../reducers/usuario_slice';
import CustomPrintModal from '../UI/CustomPrintModal';
import ActionButton from '../UI/Buttons/ActionButton';
import { apellidosNombreFullPersona } from '../../util/customFormatter';
import { InputGroup } from 'react-bootstrap';
import { getEstadoSimple } from '../../util/valueCalculator';
import Swal from 'sweetalert2';
import FormRolesUsuario from './FormRolesUsuario';
import { useNavigate } from 'react-router-dom';
//import './ListUsuarios.css';  // Importa tu archivo CSS

const ListUsuarioss = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const usuariosConRoles = useSelector(state => state.usuario.usuarios || []);

    const [showModal, setShowModal] = useState(false);
    const [showRolModal, setShowRolModal] = useState(false);
    const [currentUsuario, setCurrentUsuario] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key1: null,key2: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [printContent, setPrintContent] = useState({ head: [], body: [] });

    useEffect(() => {
        dispatch(fetchUsuarios());
    }, [dispatch]);

 
    const handleDelete = id => {
        Swal.fire({
          title: '¿Estás seguro?',
          text: "¡No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#464646',
          confirmButtonText: 'Sí, eliminarlo!',
           cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(removeUsuario(id)).unwrap().then(() => {
              Swal.fire('¡Eliminado!', 'El usuario ha sido eliminado.', 'success');
            }).catch((error) => {

                console.log("error en delete", error);
                // Usar el mensaje específico del backend si está disponible
                const errorMessage = error?.messages?.[0] || 'Ocurrió un error al eliminar el usuario';
            
                Swal.fire('Error', errorMessage, 'error');
            });
    }});
        
      };

    const handleEdit = usuario => {
        setCurrentUsuario(usuario);
        setShowModal(true);
    };

    const handleCreate = () => {
        setCurrentUsuario(null);
        setShowModal(true);
    };

    const handleManageRoles = usuario => {
        setCurrentUsuario(usuario);
        setShowRolModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setCurrentUsuario(null);
    };
 
    const handleCloseRolModal = () => {
        setShowRolModal(false);
        setCurrentUsuario(null);
        dispatch(fetchUsuarios());
    };
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };
      
  const sortedList = useMemo(() => {
      // FILTRADO
      let filteredUsuarios= usuariosConRoles.filter(usuario => {
        const matchesSearch = usuario.persona 
          ? `${usuario.usuario} ${apellidosNombreFullPersona(usuario.persona, "ci")}`.toLowerCase().includes(searchTerm.toLowerCase()) 
          : false;

        return matchesSearch;
      });
      let sortedData = [...filteredUsuarios];

        if (sortConfig.key2) {
            sortedData.sort((a, b) => {
        let aValue, bValue;

        if (sortConfig.key1 !== "") {
            aValue = a[sortConfig.key1][sortConfig.key2];
            bValue = b[sortConfig.key1][sortConfig.key2];
        } else {
            aValue = a[sortConfig.key2];
            bValue = b[sortConfig.key2];
        }

        if (aValue === null ) return 1;
        if (bValue === null ) return -1;

        if (aValue < bValue) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });
}

return sortedData;
}, [usuariosConRoles, sortConfig, searchTerm]);

    const handleShowPreview = () => {
        setPrintContent(getPreviewContent());
        setShowPreviewModal(true);
    };

    const handleClosePreview = () => {
        setShowPreviewModal(false);
    };
    const handleSort = (key1, key2) => {
        if (sortConfig.direction === 'desc') {
          setSortConfig({ key1:null, key2: null, direction: 'asc' });
          return;
        }
        let direction = 'asc';
        if (sortConfig.key1 === key1 && sortConfig.key2 === key2 && sortConfig.direction === 'asc') {
          direction = 'desc';
        } else if (sortConfig.key1 === key1 && sortConfig.key2 === key2 && sortConfig.direction === 'desc') {
          direction = null; // Si ya estaba descendente, lo dejamos sin ordenar
        }
        setSortConfig({key1, key2, direction });
      };
    //IMPRESION
    const getPreviewContent = () => {
        const content = {
        head: [['N°', 'Usuario', 'Persona', 'Estado']],
        body: sortedList.map((usuario, index) => [
            index+1,
            usuario.usuario,
            apellidosNombreFullPersona(usuario.persona),
            getEstadoSimple(usuario.estado_sql)|| 'N/A',
        ])
        };
        return content;
    };
    //EXCEL
    const handleExport = () => {
        const contentArrays = getPreviewContent()
        // Combinar las cabeceras y los datos
        const exportData = [...contentArrays.head, ...contentArrays.body];
        // Crear la hoja de trabajo con las cabeceras personalizadas
        const worksheet = XLSX.utils.aoa_to_sheet(exportData); // Utiliza aoa_to_sheet para definir tanto cabecera como datos
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");
        // Exportar el archivo Excel
        XLSX.writeFile(workbook, "usuarios.xlsx");
    };
      
    const handleBack = () => {
        navigate("/admin");
      };
    return (
        <div className="list-container list0">
        <h1 className='table-title'>Lista de Usuarios</h1>
        <div className="list-content">
        <div className="list-container-header">
          <div className="left-buttons">
            <button title="Volver" onClick={handleBack} className="icon-button btn-transparent mr-3"><i className="bi bi-arrow-left"></i></button>
          </div>
          <div className="right-buttons">
            <button title="Imprimir" onClick={handleShowPreview} className="icon-button btn-transparent"><i className="bi bi-printer"></i></button>
            <button title="Exportar a excel" onDoubleClick={handleExport} className="icon-button btn-transparent mr-3"><i className="bi bi-file-spreadsheet"></i></button>
            <ActionButton onClick={handleCreate} outline icon='plus' floatEnd>
              Nuevo Usuario
            </ActionButton>
          </div>
        </div>
        <div className="list-container-header">
            <InputGroup size="sm">
                <InputGroup.Text>
                <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control
                    size='sm'
                    type="text"
                    placeholder="Busca por usuario, C.I. o nombre"
                    className="form-control"
                    value={searchTerm}
                    onChange={handleSearch}
                    />
            </InputGroup>
            </div>
        <div className='table-container'>
                <Table striped bordered hover className="table-bordered">
                    <thead className="sticky-header1">
                        <tr className='text-center'>
                        <th className='col-cod'>N°</th>
                        <th onClick={() => handleSort('','usuario')}>
                            Usuario
                            {sortConfig.key2 === 'usuario' && (
                                sortConfig.direction === 'asc' ? <i className="bi bi-arrow-up"></i> : <i className="bi bi-arrow-down"></i>
                            )}
                            </th>
                        <th onClick={() => handleSort('persona','apellido1')}>
                            Persona
                            {sortConfig.key2 === 'apellido1' && (
                            sortConfig.direction === 'asc' ? <i className="bi bi-arrow-up"></i> : <i className="bi bi-arrow-down"></i>
                            )}
                        </th>
                        <th onClick={() => handleSort('','estado')}>
                            Estado
                            {sortConfig.key2 === 'estado' && (
                                sortConfig.direction === 'asc' ? <i className="bi bi-arrow-up"></i> : <i className="bi bi-arrow-down"></i>
                            )}
                            </th>
                            <th>Rol(es)</th>
                            <th className='col-actions3'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedList.map((usuario, index) => (
                            <tr key={usuario.id}>
                                <td>{index+1}</td>
                                <td>{usuario.usuario}</td>
                                 <td>{apellidosNombreFullPersona(usuario.persona, "ci")}</td>
                                 <td>{getEstadoSimple(usuario.estado_sql)}</td>
                                 <td>
                                    <span style={{ fontSize: '0.95rem' }}>
                                        {usuario.roles.map(r => r.nombre).join(', ')}
                                    </span>
                                    </td>
                                <td>
                                <button className="icon-button btn-secondary-outline" title="Editar usuario" onClick={() => handleEdit(usuario)}>
                                    <i className="bi bi-pencil"></i>
                                </button>
                                <button className="icon-button btn-secondary-outline" title="Eliminar usuario" onClick={() => handleDelete(usuario.id)}>
                                    <i className="bi bi-trash"></i>
                                </button>
                                <button className="btn-sm btn-secondary-outline" title="Gestionar Roles del usuario" onClick={() => handleManageRoles(usuario)}>
                                   Roles
                                </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            </div>
            
{/*            
            <ActionsContainer onPrint={handleShowPreview} /> */}
            <FormUsuario currentUsuario={currentUsuario} showModal={showModal} handleClose={handleClose} />
            {showRolModal && currentUsuario && (
                <FormRolesUsuario show={showRolModal} handleClose={handleCloseRolModal} usuario={currentUsuario} />
            )}
            <CustomPrintModal
                show={showPreviewModal}
                handleClose={handleClosePreview}
                title1="LISTA DE USUARIOS"
                title2=""
                content={printContent}
                copia={false}
            />
        </div>
    );
};

export default ListUsuarioss;
